export default "__VITE_ASSET__c38da01e__"